import router from "./router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Message } from "element-ui";
import { Route } from "vue-router";
import { UserModule } from "@/store/modules/user";
import { AppModule } from "@/store/modules/app";
import settings from "./settings";

NProgress.configure({ showSpinner: false });

const whiteList = ["/login"];

const getPageTitle = (key: string) => {
    // const hasKey = i18n.te(`route.${key}`);

    // if (hasKey) {
    //     const pageName = i18n.t(`route.${key}`);
    //     return `${pageName} - ${settings.title}`;
    // }
    return `${settings.title}`;
};

router.beforeEach(async (to: Route, _: Route, next: any) => {
    // Start progress bar
    NProgress.start();

    // keep page status
    if (AppModule.requestMsg.code != 1000) {
        sessionStorage.setItem(
            _.path,
            JSON.stringify(AppModule.requestMsg)
        );
    }

    // 处理一键登录
    try {
        if (to.path == '/login' && to.query && to.query.openid) {
            await UserModule.OneClickLogin(to.query.openid.toString())

            next('/home')
            return
        }
    } catch (err) {
        console.log(err, "一键登录异常");

    }


    if (UserModule.token) {
        if (to.path === "/login") {
            next({ path: "/" });

            NProgress.done();
        } else {
            if (!UserModule.account) {
                try {
                    await UserModule.GetUserInfo();
                    await UserModule.GetMainData();

                    const { path, query } = to;
                    AppModule.InitApp({ path, params: query })

                    next({ ...to, replace: true });
                } catch (err) {
                    UserModule.ResetToken();
                    Message.error("Has Error");
                    next(`/login?redirect=${to.path}`);
                    NProgress.done();
                }
            } else {
                if (to.name == null) {
                    next("/error");
                } else {
                    try {
                        next();
                    }
                    catch (e) {
                        console.log(e)
                    }

                }
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next(`/login?redirect=${to.path}`);
            NProgress.done();
        }
    }
});

router.afterEach((to: Route) => {
    let pageStatus: any = sessionStorage.getItem(to.path);

    if (pageStatus) {
        let h = JSON.parse(pageStatus);

        AppModule.SET_REQUEST_MSG(h);
        sessionStorage.removeItem(to.path);
    } else {
        AppModule.SET_REQUEST_MSG({ code: 1000 });
    }

    NProgress.done();

    document.title = getPageTitle(to.meta?.title);
});
